module.exports = "/static/images/menu-groups.jpg";